import { render, staticRenderFns } from "./AboutSeoText.vue?vue&type=template&id=198f4756&scoped=true&"
import script from "./AboutSeoText.vue?vue&type=script&lang=js&"
export * from "./AboutSeoText.vue?vue&type=script&lang=js&"
import style0 from "./AboutSeoText.vue?vue&type=style&index=0&id=198f4756&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198f4756",
  null
  
)

export default component.exports